<p-avatar
	[image]="showImage ? imageUrl : undefined"
	[label]="!showImage ? initials : undefined"
	shape="circle"
	styleClass="user-avatar__prime"
	(onImageError)="onImageError()" />
